import type { Browser } from 'detect-browser';

export const UNSUPPORTED_BROWSERS: Browser[] = [
  'ie',
  'bb10',
  'silk',
  'aol',
];
